console.log("Hello from current_weather_plots.js")